import { CommonState, ListParams, Pagination } from './common';
import { TIntention } from './intentions';
import { Images } from './photo';

export enum StoryPlatform {
  ANDROID = 'android',
  HUAWEI = 'huawei',
  IOS = 'ios',
  WEB_DESKTOP = 'web-desktop',
  WEB_MOBILE = 'web-mobile',
}

export type StoryComponent = {
  id: number;
  text: string;
  title: string;
  sort: number | null;
  playtime: number;
  button: string;
  images: Images;
  created_at: string | null;
  updated_at: string | null;
  intention: TIntention | null;
  button_color: string | null;
  button_text_color: string | null;
};

export type Story = {
  id: number;
  title: string;
  images: Images;
  sort: number | null;
  created_at?: string | null;
  updated_at?: string | null;
  components: StoryComponent[];
  boot: boolean;
  active: boolean;
  platforms: StoryPlatform[];
};

export type StoryList = {
  data?: Story[];
  meta?: Pagination;
};

export type StoryListParams = ListParams & {
  sort?: string;
};

export type StoryState = CommonState & {
  storyList: StoryList;
  storyListParams: StoryListParams;
  story: Story | null;
};

export const TYPES = [
  { label: 'html', option: 'html' },
  { label: 'list', option: 'list' },
];

export type ParamsStoryForForm = Omit<Story, 'id' | 'sort' | 'created_at' | 'updated_at'>;

export type ParamMassStorySort = { id: number; sort: number | null };
